import { ReadonlyURLSearchParams } from 'next/navigation';

export type SelectedFiltersMap = Map<string, Set<string>>;

export const getSelectedFilters = (
	groupKeys: Array<string>,
	subjectKey: string | undefined,
	searchParams: ReadonlyURLSearchParams,
) => {
	const selectedFilters: SelectedFiltersMap = new Map();
	const allGroupKeys =
		subjectKey == null ? groupKeys : [subjectKey, ...groupKeys];

	for (const groupKey of allGroupKeys) {
		const newSelection = searchParams.getAll(groupKey);
		selectedFilters.set(groupKey, new Set(newSelection));
	}

	return selectedFilters;
};
